/**
 * @generated SignedSource<<fe8b9c8ea8a79db852023a1dd1f39aee>>
 * @relayHash 9d86d74e9aa49088c509319233080798
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c13037c71bd021df8a7151de2d58a91f99e178b8bd0402d1d4dcc79cc904ecc7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DefaultAgentResultsRovoQuery$variables = {
  cloudId: string;
  includeRovo: boolean;
  product?: string | null;
};
export type DefaultAgentResultsRovoQuery$data = {
  readonly rovo?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
      } | null;
    }>;
  } | null;
};
export type DefaultAgentResultsRovoQuery = {
  response: DefaultAgentResultsRovoQuery$data;
  variables: DefaultAgentResultsRovoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRovo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "creatorTypes": [
        "ROVO_CHAT"
      ]
    }
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DefaultAgentResultsRovoQuery",
    "selections": [
      {
        "condition": "includeRovo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "rovo",
            "args": (v3/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "AgentCardRelay_StudioBrowseKit"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "DefaultAgentResultsRovoQuery",
    "selections": [
      {
        "condition": "includeRovo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "rovo",
            "args": (v3/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "icon"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "identityAccount",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "appType"
                              }
                            ],
                            "type": "AppUser"
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "creatorType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "forgeCreator"
                      },
                      {
                        "concreteType": "TeamV2",
                        "kind": "LinkedField",
                        "name": "authoringTeam",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                          },
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c13037c71bd021df8a7151de2d58a91f99e178b8bd0402d1d4dcc79cc904ecc7",
    "metadata": {},
    "name": "DefaultAgentResultsRovoQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e753d42436eb3c173d85becb6331c76";

export default node;
